export default __webpack_public_path__ + "static/media/forbes-logo-white.ceee5a13.svg";